import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/help/banner.png'
import _imports_1 from '@/assets/help/banner_m.png'


const _withScopeId = n => (_pushScopeId("data-v-15e20940"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "help-container" }
const _hoisted_2 = {
  key: 0,
  class: "banner",
  src: _imports_0,
  alt: ""
}
const _hoisted_3 = {
  key: 1,
  class: "banner banner-m",
  src: _imports_1,
  alt: ""
}
const _hoisted_4 = { class: "main-content pt100 pb100" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title pl13" }, "帮助中心", -1))
const _hoisted_6 = { class: "help-table" }
const _hoisted_7 = { class: "item-title mb20" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 0,
  class: "flex-c-center pt40 pb40 page-box"
}
const _hoisted_10 = {
  key: 1,
  class: "flex-c-center pt40 pb40 page-box-m"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "help-foot mt50" }, [
  /*#__PURE__*/_createElementVNode("p", null, "我们的目标是为您提供最安全、最可控的PDF文件分享体验。无论您是个人用户还是企业用户，我们都为您提供了一站式的解决方案，以确保您分享文件的安全性，并且更好地管理和控制对PDF文件的使用。"),
  /*#__PURE__*/_createElementVNode("h3", { class: "mt20" }, "欢迎尝试使用笔熊分享。我们相信，您将体验到更智能、更安全的PDF文件分享服务。")
], -1))

import { ref } from 'vue'
import checkPc from '@/utils/checkPc'
import {helpCenterApi} from "@/api/common";

/**
 * 判断是否PC端
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const isPC = checkPc()

// 定义变量
const state = ref({
  data: [],
  config: {
    total: 0
  },
  params: {
    page: 1,
    limit: 5
  }
})

/**
 * 获取页面信息
 */
const getPageInfo = async () => {
  const list:any = await helpCenterApi(state.value.params);
  console.log(list);
  state.value.data = list.data;
  state.value.config.total = list.total;
}
getPageInfo();

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isPC))
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : (_openBlock(), _createElementBlock("img", _hoisted_3)),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.value.data, (v, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "help-table-item mt30"
          }, [
            _createElementVNode("h3", _hoisted_7, _toDisplayString(v.title), 1),
            _createElementVNode("p", {
              class: "item-desc",
              innerHTML: v.description
            }, null, 8, _hoisted_8)
          ]))
        }), 128))
      ]),
      (_unref(isPC))
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_el_pagination, {
              background: "",
              layout: "prev, pager, next",
              "current-page": state.value.params.page,
              "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((state.value.params.page) = $event)),
              "page-size": state.value.params.limit,
              "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((state.value.params.limit) = $event)),
              total: state.value.config.total,
              onCurrentChange: getPageInfo
            }, null, 8, ["current-page", "page-size", "total"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_el_pagination, {
              background: "",
              layout: "prev, next",
              "current-page": state.value.params.page,
              "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((state.value.params.page) = $event)),
              "page-size": state.value.params.limit,
              "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((state.value.params.limit) = $event)),
              total: state.value.config.total,
              onCurrentChange: getPageInfo
            }, null, 8, ["current-page", "page-size", "total"])
          ])),
      _hoisted_11
    ])
  ]))
}
}

})